import Vue from 'vue';
import VueRouter from 'vue-router';
import Archive from '../views/Archive.vue';
import Product from '../views/Product.vue';

Vue.use(VueRouter);
let routes = [
  {
    path: `${ws_vue_store.sub_urls.shop}`,
    alias: `${ws_vue_store.sub_urls.shop}/`,
    name: 'Archive',
    component: Archive,
  },
  {
    path: `/${ws_vue_store.sub_urls.category_base}/:category_slug/:sub_category_slug?/*`,
    name: 'CategoryArchive',
    redirect: { name: 'Archive' },
  },
];

if(ws_vue_store.single_product_page_enabled == "1"){
  routes.push({
    path: `/${ws_vue_store.sub_urls.product_base}/:slug`,
    name: 'Product',
    component: Product,
  })
} else {
  routes.push({
    path: `/${ws_vue_store.sub_urls.product_base}/:slug`,
    beforeEnter(to, from, next) {
      if(window.location.href != ws_vue_store.site_url + to.path){
        let baseurl = ws_vue_store.site_url + to.path;
        let newUrl = new URL(baseurl);
        Object.keys(to.query).forEach(q => {
          newUrl.searchParams.append(q, to.query[q]);
        })
        window.location.href = newUrl;
      }
    }
  })
}

const router = new VueRouter({
  base: ws_vue_store.base_url,
  mode: 'history',
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   }
  //   return { x: 0, y: 0 };
  // },
});

export default router;
